module.exports = __webpack_public_path__ + "img/dhfesta_info_0403.f7d0e666.png";